import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  onLinkClick(e) {
    window.history.pushState({}, null, e.currentTarget.href)
    Turbo.navigator.history.push(e.currentTarget.href)
  }
}